export default __webpack_public_path__ + "static/media/river.ee4c2a5f.png";